import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { ApiSettingsComponent } from './api-settings.component';
import { ApiSettingsStates }    from './api-settings.states';
import { BookingsModule }       from '../bookings/bookings.module';
import { SharedModule }         from '../shared/shared.module';
import { WsApiModule }          from '../ws-api/ws-api.module';

@NgModule({
  declarations: [
    ApiSettingsComponent
  ],
  entryComponents: [
    ApiSettingsComponent,
  ],
  imports: [
    BookingsModule,
    SharedModule,
    WsApiModule,

    UIRouterUpgradeModule.forChild({ states: ApiSettingsStates })
  ]
})
export class ApiSettingsModule {}
